// Firebase RTDB rejects writes whose value contains `undefined` — `push`/`set`
// throw synchronously ("value argument contains undefined in property ..."). Our
// command/session payloads carry optional fields (e.g. `embedHost`, only set for
// embed runtimes) that are `undefined` otherwise, so strip unset keys before any
// write. Shallow is enough: these payloads are flat.
export const stripUndefined = <T extends Record<string, unknown>>(obj: T): Partial<T> =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined)) as Partial<T>;
